export const FALLBACK_PRECISION = 18
export const FALLBACK_SYMBOL = 'N/A'
